import { NavLink } from 'react-router-dom'
import { useConversas } from '../../api/queries/documentos'
import { BotaoLink } from '../../components/Botao'
import { Esqueleto } from '../../components/Estados'
import { IconeNovo } from '../../components/Icones'
import { cn } from '../../lib/cn'
import { dataHora } from '../../lib/datas'
import { TEXTOS } from '../../lib/glossario'

/**
 * As conversas da pessoa, a mais recente em cima, e o botão de começar outra.
 *
 * Só a própria pessoa vê esta lista — o servidor filtra pelo dono, e a frase de vazio diz isso,
 * porque "quem mais vê o que eu perguntei?" é a dúvida natural de quem pergunta sobre um contrato.
 *
 * @returns a lista
 */
export function ListaDeConversas() {
  const t = TEXTOS.consulta
  const conversas = useConversas()
  const lista = conversas.data ?? []

  return (
    <nav aria-label={t.suasConversas} className="space-y-3">
      <BotaoLink to="/consulta" aparencia="secundario" className="w-full">
        <IconeNovo className="h-4 w-4" />
        {t.novaConversa}
      </BotaoLink>
      <h2 className="px-1 pt-2 text-xs font-semibold text-slate-500">{t.suasConversas}</h2>
      {conversas.isLoading && <Esqueleto linhas={3} />}
      {conversas.isSuccess && lista.length === 0 && <p className="px-1 text-xs text-slate-500">{t.semConversas}</p>}
      <ul className="space-y-0.5">
        {lista.map((conversa) => (
          <li key={conversa.id}>
            <NavLink
              to={`/consulta/${conversa.id}`}
              className={({ isActive }) =>
                cn(
                  'block rounded-lg px-3 py-2 text-sm transition-colors',
                  isActive ? 'bg-niteroi-50 font-medium text-niteroi-800' : 'text-slate-700 hover:bg-white',
                )
              }
            >
              <span className="line-clamp-2">{conversa.titulo}</span>
              <span className="mt-0.5 block text-xs font-normal text-slate-400">
                {dataHora(conversa.atualizadaEm)} ·{' '}
                {conversa.perguntas === 1 ? '1 pergunta' : `${conversa.perguntas} perguntas`}
              </span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  )
}
